// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2RSFd","title":"ClientInsurance_title__m3Cid","itemText":"ClientInsurance_itemText__31a2m"};